import loadable from '@loadable/component';

export const LazyEventRedirect = loadable(() => import(/* webpackChunkName: "content/eventredirect" */ './EventRedirect'));
